import axios from './api'

/**
 * API接口
 */
export default {

  // 获取验证码
  captcha(params) {
    return axios.get('/admin/captcha', JSON.stringify(params))
  },

  // 登录系统
  login(params) {
    return axios.post('/admin/login', params)
  },

  // 获取登录信息
  getLoginInfo(params) {
    return axios.get('/admin/getLoginInfo', JSON.stringify(params))
  },

  // 获取权限菜单
  authList(params) {
    return axios.get('/admin/getMenuList', JSON.stringify(params))
  },

  // 退出登录
  logout(params) {
    return axios.get('/login/logout', JSON.stringify(params))
  },

  dashboard(params) {
    return axios({
      method: "GET",
      url: '/index/dashboard?type=' + params.type,
      data: {}
    })
  },

  editPassword(params) {
    return axios.post('/login/editPassword', params)
  },
  profile(params) {
    return axios.post('/login/profile', params)
  },

}



// WEBPACK FOOTER //
// ./src/api/login.js